import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { CassandraLinkedService } from 'app/model/linkedservice/cassandra.linkedservice';

import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { CassandraDataset } from 'app/model/dataset/cassandra.dataset';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CassandraDataset),
    asynchronous: true,
    adapts: _.merge({
        properties: {
            typeProperties: {
                keyspace: '*'
            }
        }
    }, tabularTypeDatasetAdapts)
})
export class CassandraDatasetAdapter extends TabularTypeDatasetAdapter<CassandraDataset, Model.DatasetResource> {
    protected async _toResource(dataset: CassandraDataset): Promise<Model.DatasetResource> {
        const linkedService = dataset.linkedService as CassandraLinkedService;
        const modelDatasetResource = await this._toResourceInternal(dataset, Metamodel.modelFor(CassandraDataset).name,null,'keyspace','tableName');
        const modelDataset = this.properties(modelDatasetResource) as Model.CassandraTableDataset;
        let keyspace = linkedService.version === 'v2' ? ValueAdapter.toResource(dataset, CassandraDataset.SCHEMA) : ValueAdapter.toResource(dataset, CassandraDataset.KEY_SPACE);
        if (keyspace != null && keyspace.type !== 'Expression') {
            keyspace = keyspace === '' ? undefined : keyspace;
        }
        modelDataset.typeProperties = _.merge(modelDataset.typeProperties, { keyspace });
        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: CassandraDataset): Promise<CassandraDataset> {
        dataset = await this._toModelInternal(modelDatasetResource, dataset, CassandraDataset.MODEL, null, 'keyspace', 'tableName');
        dataset.isV2 = true;
        const model = modelDatasetResource.properties as Model.CassandraTableDataset;
        if (model?.typeProperties?.keyspace) {
            ValueAdapter.toModel(dataset, CassandraDataset.KEY_SPACE, model.typeProperties.keyspace);
        }
        return dataset;
    }
}
